const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_MyTaskList":
      return { ...state, List: payload };
    case "SAVE_MyTaskProgressRecords":
      return { ...state, ProgressRecords: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
